
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowLeft, Home } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ErrorState } from "@/components/ui/error-state";

const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn } = useAuth();
  
  const from = location.state?.from?.pathname || "/";
  const reason = location.state?.reason || "You don't have permission to access this page.";

  const handleLogin = () => {
    signIn("", "").then(() => {
      navigate(from, { replace: true });
    });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-white dark:bg-fraudeye-primary">
      <ErrorState 
        title="Access Denied"
        description={reason}
        className="max-w-md bg-white dark:bg-fraudeye-primary"
        variant="default"
      />
      
      <div className="flex gap-4 mt-6">
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          className="flex items-center"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Go Back
        </Button>
        <Button 
          className="bg-fraudeye-accent hover:bg-fraudeye-highlight flex items-center"
          onClick={() => navigate("/")}
        >
          <Home className="h-4 w-4 mr-2" />
          Go to Home
        </Button>
      </div>
      
      {!location.pathname.includes('/login') && (
        <Button
          variant="link"
          onClick={handleLogin}
          className="mt-4"
        >
          Login with different account
        </Button>
      )}
    </div>
  );
};

export default Unauthorized;
